// @ts-nocheck
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ErrorMessage from '../../components/ErrorMessage';
import SuccessMessage from '../../components/SuccessMessage';
import { URL } from '../../service/Service';

const emptyForm = {
  customerID: '',
  name: '',
  nif: '',
  notes: '',
  url: '',
  dateCalculate: '',
};

const CreateClient = ({ button1, button2 }) => {
  const [formData, setFormData] = useState(emptyForm);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [messageErr, setMessageErr] = useState('');
  const [subtitleErr, setSubtitleErr] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { id } = useParams();
  const token = sessionStorage.getItem('jwt');

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const formatTimestamp = () => {
    if (!selectedDate || !selectedTime) return '';
    const date = new Date(`${selectedDate}T${selectedTime}`);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const clearErrorMessages = () => {
    setMessageErr('');
    setSubtitleErr('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setSuccessMessage('');
    setMessageErr('');
    setSubtitleErr('');

    try {
      const response = await fetch(`${URL}/api/partners/${id}/costumer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...formData,
          url: formData.url?.trim(),
          dateCalculate: formatTimestamp(),
        }),
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Não foi possível criar o cliente.');
      }

      setSuccessMessage('Novo cliente criado com sucesso.');
      setFormData(emptyForm);
      setSelectedDate('');
      setSelectedTime('');
      setTimeout(() => window.location.reload(), 1200);
    } catch (error) {
      setMessageErr('Não foi possível criar o cliente.');
      setSubtitleErr(error.message || 'Verifique se o CID já existe e se os campos estão corretos.');
      setTimeout(clearErrorMessages, 4000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-xl ring-1 ring-gray-100">
      {successMessage && <SuccessMessage message={successMessage} />}
      {messageErr && <ErrorMessage messageErr={messageErr} subtitleErr={subtitleErr} duration={3000} />}

      <div className="mb-6 border-b border-gray-100 pb-5">
        <span className="inline-flex rounded-full bg-green-cl/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-green-cl">
          Novo cliente
        </span>
        <h3 className="mt-3 text-2xl font-black text-gray-950">Associar cliente ao parceiro</h3>
        <p className="mt-1 text-sm text-gray-500">
          Introduza o CID, dados fiscais e website. Pode usar domínio com ou sem <strong>www</strong> e sem prefixo <strong>https://</strong>.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <label className="block">
          <span className="text-sm font-semibold text-gray-700">ID de Cliente (CID)</span>
          <input type="text" name="customerID" value={formData.customerID} onChange={handleChange} required
            className="mt-2 block w-full rounded-xl border-gray-300 px-4 py-3 shadow-sm focus:border-green-cl focus:ring-green-cl" />
        </label>

        <label className="block">
          <span className="text-sm font-semibold text-gray-700">Nome</span>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required
            className="mt-2 block w-full rounded-xl border-gray-300 px-4 py-3 shadow-sm focus:border-green-cl focus:ring-green-cl" />
        </label>

        <label className="block">
          <span className="text-sm font-semibold text-gray-700">NIF</span>
          <input type="text" name="nif" value={formData.nif} onChange={handleChange} placeholder="Ex.: 259043443"
            className="mt-2 block w-full rounded-xl border-gray-300 px-4 py-3 shadow-sm focus:border-green-cl focus:ring-green-cl" />
        </label>

        <label className="block">
          <span className="text-sm font-semibold text-gray-700">Website</span>
          <input type="text" name="url" value={formData.url} onChange={handleChange} placeholder="exemplo.pt ou www.exemplo.pt"
            className="mt-2 block w-full rounded-xl border-gray-300 px-4 py-3 shadow-sm focus:border-green-cl focus:ring-green-cl" />
        </label>

        <label className="block">
          <span className="text-sm font-semibold text-gray-700">Data do último levantamento</span>
          <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} required
            className="mt-2 block w-full rounded-xl border-gray-300 px-4 py-3 shadow-sm focus:border-green-cl focus:ring-green-cl" />
        </label>

        <label className="block">
          <span className="text-sm font-semibold text-gray-700">Hora do último levantamento</span>
          <input type="time" value={selectedTime} onChange={(e) => setSelectedTime(e.target.value)} required step="1"
            className="mt-2 block w-full rounded-xl border-gray-300 px-4 py-3 shadow-sm focus:border-green-cl focus:ring-green-cl" />
        </label>

        <label className="block md:col-span-2">
          <span className="text-sm font-semibold text-gray-700">Notas</span>
          <textarea name="notes" rows={4} value={formData.notes} onChange={handleChange}
            placeholder="Informação interna, contexto comercial ou observações."
            className="mt-2 block w-full rounded-xl border-gray-300 px-4 py-3 shadow-sm focus:border-green-cl focus:ring-green-cl" />
        </label>
      </div>

      <div className="mt-6 flex flex-col-reverse gap-3 border-t border-gray-100 pt-5 sm:flex-row sm:justify-end">
        {button1}
        {button2}
        <button type="submit" disabled={submitting}
          className="rounded-xl bg-green-cl px-5 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-green-900 disabled:cursor-not-allowed disabled:opacity-60">
          {submitting ? 'A guardar...' : 'Criar cliente'}
        </button>
      </div>
    </form>
  );
};

export default CreateClient;
